module.exports = __webpack_public_path__ + "img/shield_fail.f9e607b5.svg";